export const formatAmount = (amount: number): any => {
  const formateur = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  
  return formateur.format(amount);
}